const React = require('react');
const trim = require('mn-utils/trim');
const noop = require('mn-utils/noop');
const {
  TERMINAL_COLOR_ITEMS,
} = require('../../../../constants');
const {
  backLocation,
} = require('../../../../router');
const WrapperWithLoading = require('../../../dumb/WrapperWithLoading');
const TextFieldH = require('../../../dumb/TextField/H');
const Select = require('../../../dumb/Select/B');
const ButtonI = require('../../../dumb/Button/I');
const ButtonBlack = require('../../../dumb/Button/Black');
const MerchantId = require('./MerchantId');


const STATUS_ITEMS = [
  {id: 'ordered', name: 'Ordered'},
  {id: 'processing', name: 'Processing'},
  {id: 'ready', name: 'Ready'},
];


module.exports = (props) => {
  const MAX_WIDTH = 250;
  const {
    state,
    skip,
  } = props;
  const {
    clicked,
    color,
    status,
  } = state;
  const merchantId = state.merchant_id || '';
  const name = state.name || '';
  const imei = state.imei || '';
  const invalidName = !trim(name);
  const invalidColor = !color;
  const invalidStatus = !status;
  const invalidImei = !trim(imei);
  const invalidMerchantId = !trim(merchantId);
  const disabled = invalidName
    || invalidColor
    || invalidStatus
    || (!skip && (invalidImei || invalidMerchantId));

  return (
    <WrapperWithLoading
      className="stroke0>circle"
      loading={state.loading}
    >
      <div
        className="fw5 f18 tc c1D1E20 hmin26"
      >{name}</div>
      <TextFieldH
        className="mt45"
        error={clicked && invalidName}
        type="text"
        label="Name"
        value={name}
        onChange={props.handleChangeName}
        maxLength={MAX_WIDTH}
      />
      <MerchantId
        className="mt20"
        disabled={skip}
        error={!skip && clicked && invalidMerchantId}
        // helperText={!merchantId}
        type="text"
        label={skip ? 'Merchant ID' : 'Merchant email'}
        value={merchantId}
        onChange={props.handleMerchantId}
        maxLength={MAX_WIDTH}
      />
      <TextFieldH
        className="mt20"
        error={!skip && clicked && invalidImei}
        label="IMEI"
        value={imei}
        onChange={props.blockIMEI ? noop : props.handleChangeImei}
        maxLength={MAX_WIDTH}
        disabled={props.blockIMEI}
      />
      <Select
        className="mt20"
        error={clicked && invalidStatus}
        label="Status"
        propName="name"
        propValue="id"
        items={STATUS_ITEMS}
        value={status}
        onChange={props.handleChangeStatus}
      />
      <Select
        className="mt20"
        error={clicked && invalidColor}
        type="text"
        label="Color"
        propName="name"
        propValue="name"
        items={TERMINAL_COLOR_ITEMS}
        value={color}
        onChange={props.handleChangeColor}
      />
      <div className="mt60 layoutRow fhaE fvaC">
        <ButtonI
          onClick={backLocation}
        >Cancel</ButtonI>
        <ButtonBlack
          className="ml15"
          disabled={clicked && disabled}
          onClick={() => {
            disabled
              ? props.onTry()
              : props.onSend({
                name: trim(name),
                color,
                status,
                imei: trim(imei),
                merchant_id: trim(merchantId),
                // enabled: false,
                // distributor: '',
              });
          }}
        >Save</ButtonBlack>
      </div>
    </WrapperWithLoading>
  );
};
